<template>
  <el-card class="box-card">
    <app-modal-new-project v-if="addNewProject"></app-modal-new-project>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/' }">Admin</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/users' }">Usuarios</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/users/new' }">{{
        breadcrumb
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <el-form @submit.native.prevent="save" ref="form" label-position="top" id="user">
      <el-row type="flex" justify="space-between">
        <el-col :span="11">
          <el-form-item label="Email">
            <el-input v-model="form.user"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Contraseña">
            <el-input v-model="form.pass"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="11">
          <el-form-item label="Nivel de acceso">
            <select class="select" v-model="form.level">
              <option v-for="(l, i) in levels" :key="i" :value="l.id">
                {{ l.level | uppercase }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Proyectos asociados">
            <el-select
              v-model="userProjects"
              multiple
              placeholder="Select"
              @change="changueProjectc"
              @remove-tag="deleteProjectc"
            >
              <el-option
                v-for="(item, index) in projects"
                :key="index"
                :label="item.project_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <button type="text" form="a" @click="addProject()" class="el-button">
              <span>Añadir nuevo proyecto</span>
            </button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <br />
          <button
            v-if="this.showBottons"
            type="submit"
            class="el-button el-button--primary"
            form="user"
          >
            <span>{{ btn }}</span>
          </button>
          <el-button @click="close()">Cancelar</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import sha1 from "sha1";
import ApiService from "@/common/api.service";
import ModalProject from "@/components/CloudAdmin/modals/addNewProject";

export default {
  name: "userForm",
  components: {
    "app-modal-new-project": ModalProject,
  },
  created() {
    this.$root.$on("closeModal", () => this.closeModal());

    if (this.$route.params.user_id) {
      this.breadcrumb = "Edición usuario";
      this.btn = "Actualizar";
      this.id = this.$route.params.user_id;
      setTimeout(() => {
        this.getLevels();
        this.getUser();
        setTimeout(() => {
          this.getProject();
        }, 100);
      }, 200);
    } else {
      this.breadcrumb = "Nuevo usuario";
      this.btn = "Crear";
      this.getLevels();
    }
    this.getProjects();
  },
  beforeDestroy() {
    this.$root.$off("closeModal", () => this.closeModal());
  },
  data() {
    return {
      breadcrumb: false,
      btn: false,
      id: false,

      formAPI: {
        user: null,
        pass: null,
        level: 2,
      },
      passOld: false,
      levelsAPI: false,
      projectAPI: false,
      projectsAPI: false,
      delete: false,
      proyecto: false,
      proyectoOld: false,
      userProjects: false,

      showBottons: true,
      addNewProject: false,
    };
  },
  methods: {
    addProject() {
      this.addNewProject = true;
    },
    save() {
      if (this.form.user == "") {
        this.$root.$emit("msgError", "El campo Email es obligatorio");
        this.error = true;
        return false;
      } else {
        this.error = false;
      }
      if (this.form.pass == "") {
        this.$root.$emit("msgError", "El campo contraseña es obligatorio");
        this.error = true;
        return false;
      } else {
        this.error = false;
      }

      if (this.error == false) {
        if (this.passOld != this.form.pass) {
          this.form.pass = sha1(this.form.pass);
        }
        this.id > 0 ? this.update() : this.insert();
      }
    },
    async insert() {
      ApiService.post("admin/add-user", {
        token: localStorage.getItem("token"),
        form: this.form,
      }).then((response) => {
        if (
          response.data != "Algo ha fallado" &&
          response.data != "El usuario ya existe"
        ) {
          this.$root.$emit("msgSuccess", "Registro insertado");
          this.id = response.data;
          setTimeout(() => {
            this.insertUserProjects();
          }, 200);
          setTimeout(() => {
            this.$router.push("/admin/users");
          }, 1000);
        } else {
          this.$root.$emit("msgError", response.data);
        }
      });
    },
    async update() {
      ApiService.post("admin/edit-user", {
        token: localStorage.getItem("token"),
        id: this.id,
        form: this.form,
      }).then((response) => {
        if (response.data != "Algo ha fallado") {
          this.$root.$emit("msgSuccess", "Registro actualizado");
          setTimeout(() => {
            this.$router.push("/admin/users");
          }, 1000);
        } else {
          this.$root.$emit("msgError", "Algo ha fallado");
        }
      });
    },
    async getLevels() {
      ApiService.post("admin/levels", {
        token: localStorage.getItem("token"),
      }).then((response) => {
        this.levelsAPI = response.data;
      });
    },
    async getProjects() {
      ApiService.post("admin/projects", {
        token: localStorage.getItem("token"),
      }).then((response) => {
        this.projectsAPI = response.data;
      });
    },
    async getUser() {
      ApiService.post("admin/user", {
        token: localStorage.getItem("token"),
        id: this.id,
      }).then((response) => {
        this.formAPI = response.data;
        this.passOld = response.data.pass;
      });
    },
    async getProject() {
      ApiService.post("admin/project-user", {
        token: localStorage.getItem("token"),
        id: this.id,
      }).then((response) => {
        this.userProjects = response.data.map((e) => {
          return e.id;
        });
        this.proyecto = response.data;
        this.proyectoOld = response.data;
      });
    },
    insertUserProjects() {
      this.proyecto.filter((e) => {
        this.insertUserProject(e);
      });
    },
    insertUserProject(e) {
      ApiService.post("admin/add-user-project", {
        token: localStorage.getItem("token"),
        form: {
          user_id: this.id,
          project_id: e,
        },
      }).then((r) => {
        console.log(r);
      });
    },
    deleteProjectc(e) {
      if (this.id) {
        this.delete = e;
      }
    },
    changueProjectc(e) {
      // this.$root.$emit('isConnect')
      setTimeout(() => {
        if (this.id) {
          if (this.delete == false) {
            ApiService.post("admin/add-user-project", {
              token: localStorage.getItem("token"),
              form: {
                user_id: this.id,
                project_id: parseInt(e[e.length - 1]),
              },
            }).then((response) => {
              this.$root.$emit("msgSuccess", "Registro actualizado con éxito");
            });
          } else {
            this.proyectoOld.filter((p) => {
              if (this.delete == p.id) {
                ApiService.post("admin/delete-user-project", {
                  token: localStorage.getItem("token"),
                  form: {
                    user_id: this.id,
                    project_id: p.id,
                  },
                }).then((response) => {
                  this.$root.$emit("msgSuccess", "Registro actualizado con éxito");
                });
                this.delete = false;
              }
            });
          }
        }
      }, 500);
    },
    closeModal() {
      this.getProjects();
      this.addNewProject = false;
    },
    close() {
      this.$router.push("/admin/users");
    },
  },
  computed: {
    form() {
      return this.formAPI;
    },
    levels() {
      return this.levelsAPI;
    },
    projects() {
      return this.projectsAPI;
    },
  },
  filters: {
    uppercase: function (v) {
      return v.toUpperCase();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CloudAdmin/forms/user.vue